'use strict';

function ctrl($scope, Global, $window) {
    $scope.global = Global;

    $scope.iFrameWidth = $window.innerWidth-40;
    $scope.iFrameHeight = $window.innerHeight-30;
}

ctrl.$inject = ['$scope', 'Global', '$window'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/survey/survey.js
 **/